import MicroModal from 'micromodal';
import { component } from 'picoapp';

export default component( (node) => {

  const showOncePerSession = true;
  const delay = 5;
  const cookieExpirationDays = 30;
  const bb_au = 'https://beginningboutique.com.au';
  const bb_nz = 'https://beginningboutique.co.nz';
  const bb_int = 'https://beginningboutique.com';

  let shown = false;

  const config = {
    disableScroll: false
  };

  const getGeo = async (url = 'https://get.geojs.io/v1/ip/country.json') => {
    return fetch(url)
      .then(response => response.json())
      .then(data => {

        const country = data.country;

        // For Live
        //const location = window.location;
        //const au_store = 'beginningboutique.com.au';
        //const nz_store = 'beginningboutique.co.nz';
        //const us_store = 'beginningboutique.com';

        // For Testing
        const location = window.location.href;
        const au_store = 'https://finn.beginningboutique.com.au/';
        const nz_store = 'https://finn.beginningboutique.com.au/collections/brands';
        const us_store = 'https://finn.beginningboutique.com.au/collections/shoes';

        console.log(country);
        MicroModal.show('AustraliaRedirect', config);

        switch(country) {
          case 'AU':
            if (location !== au_store) { // AUS IP, but not on australian store
              MicroModal.show('AustraliaRedirect', config);
            }
            break;
          case 'NZ':
            if (location !== nz_store) { // AUS IP, but not on australian store
              MicroModal.show('NewZealandRedirect', config);
            }
            break;
          default:
            if (location !== us_store) { // AUS IP, but not on australian store
              MicroModal.show('USRedirect', config);
            }
            break;
        }

        return data;
      });
  };

  const createCookie = (name, value, days, sessionOnly) => {
    var expires = "";

    if(sessionOnly)
      expires = "; expires=0";
    else if(days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toGMTString();
    }

    document.cookie = name + "=" + value + expires + "; path=/";
  };

  const eraseCookie = (name) => {
    createCookie(name, "", -1);
  };

  const getCookie = (name) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(";");

    for(var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }

    return null;
  };

  const checkCookie = () => {
    if(cookieExpirationDays <= 0) {
      if(showOncePerSession && getCookie("bb_region") === "AU") return true;
      if(showOncePerSession && getCookie("bb_region") === "NZ") return true;
      if(showOncePerSession && getCookie("bb_region") === "INT") return true;

      eraseCookie("bb_region_shown");
      return false;
    }

    if (getCookie("bb_region_shown") === "true") return true;

    return false;
  };


  $('.redirect-btn').on('click', (e) => {
    const redirect = $(e.currentTarget).attr('data-redirect-url');
    switch(redirect) {
      case 'AUS':
        createCookie("bb_region_shown", "true", cookieExpirationDays, false);
        createCookie("bb_region", "AU", 0, true);
        window.location.href = bb_au;
        break;
      case 'NZ':
        createCookie("bb_region_shown", "true", cookieExpirationDays, false);
        createCookie("bb_region", "NZ", 0, true);
        window.location.href = bb_nz;
        break;
      case 'INT':
        createCookie("bb_region_shown", "true", cookieExpirationDays, false);
        createCookie("bb_region", "INT", 0, true);
        window.location.href = bb_int;
        break;
      default:
        break;
    }
  });

  if (!checkCookie()) {
    setTimeout(getGeo, delay);
  } else {
    // if (getCookie("bb_region") === "AU") {
    //   window.location.href = 'https://beginningboutique.com.au';
    // }
    // if (getCookie("bb_region") === "NZ") {
    //   window.location.href = 'https://beginningboutique.co.nz';
    // }
    // if (getCookie("bb_region") === "INT") {
    //   window.location.href = 'https://beginningboutique.com';
    // }
  }

});
